
const price = [
    {
        "_id": 0,
        "name": "Any",
        "array": []
    },
    {
        "_id": 1,
        "name": "Rs 0 to Rs 19,999",
        "array": [0, 19999]
    },
    {
        "_id": 2,
        "name": "Rs 20,000 to Rs 39,999",
        "array": [20000, 39999]
    },
    {
        "_id": 3,
        "name": "Rs 40,000 to Rs 59,999",
        "array": [40000, 59999]
    },
    {
        "_id": 4,
        "name": "Rs 60,000 to Rs 79,999",
        "array": [60000, 79999]
    },
    {
        "_id": 5,
        "name": "More than Rs 80,000",
        "array": [80000, 1500000]
    }
]



const roomSize = [
    {
        "_id": 1,
        "name": "14 x 16"
    },
    {
        "_id": 2,
        "name": "12 x 12"
    },
    {
        "_id": 3,
        "name": "10 x 10"
    },
    {
        "_id": 4,
        "name": "8 x 15"
    },
    {
        "_id": 5,
        "name": "12 x 18"
    },
    {
        "_id": 6,
        "name": "12 x 16"
    },
    {
        "_id": 7,
        "name": "14 x 18"
    }
]


export {
    price,
    roomSize
}